export default "__VITE_ASSET__Dka7SFAl__"